var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "body-class": "p-4" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-flex flex-row justify-content-center",
              attrs: { cols: "1" },
            },
            [_c("div", { staticClass: "step" }, [_vm._v("1")])]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "11", md: "7", lg: "5", xl: "3" } },
            [
              _c("p", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("drip-campaigns.stages.editName.question"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("material-input", {
                staticClass: "position-relative",
                attrs: {
                  id: "name",
                  name: "name",
                  label: _vm.$t("drip-campaigns.name"),
                  "label-for": "edit-campaign-name",
                  "custom-expression": "currentCampaign.name",
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }